import React from "react";
import { useTitleTextStore } from "../../../../stores/use-titletext-store";
import { TitleAndTextEditorContainer } from "../../styles";
import TitleAndText from "../titleandtext/TitleAndText";

function TitleAndTextEditor() {
  const { data, setData } = useTitleTextStore((state) => ({
    data: state.data,
    setData: state.setData,
  }));
  const updateContent = ({ value, prop }) => setData({ [prop]: value });

  return (
    <TitleAndTextEditorContainer>
      <TitleAndText data={data} updateContent={updateContent} viewMode="edit" />
    </TitleAndTextEditorContainer>
  );
}

export default TitleAndTextEditor;
